module.exports = __webpack_public_path__ + "static/media/portal-gestion-online_new.5c1cd906.jpg";